import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { gantActions } from '../../../store/reducers/gantSlice/gantSlice';

export const useModeTabs = () => {
    const dispatch = useDispatch();
    const { settings, activeTab } = useSelector((state) => state.gantReducer);

    const onChangeActiveTab = useCallback((tab) => {
        dispatch(gantActions.changeTab(tab));
    }, []);

    const changeTab = (value) => {
        $.ajax({
            url: routable.getRoute('estimateScheduleSaveSettings'),
            data: {
                duration: value,
                viewMaterial: settings.isShowMHD ? 1 : 0,
            },
            success: function () {},
        });
        onChangeActiveTab(value);
    };

    return { activeTab, changeTab };
};
